import React from 'react';
export function LearningOutcomes() {
  return <section className="mb-12" data-id="element-368">
      <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-369">
        Learning Outcomes
      </h2>
      <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-8 border border-green-100" data-id="element-370">
        <p className="text-gray-700 mb-6" data-id="element-371">
          By the end of this course, you will have developed the essential
          skills and confidence to:
        </p>
        <ul className="space-y-4" data-id="element-372">
          <li className="flex items-start gap-3" data-id="element-373">
            <span className="flex-shrink-0 w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold" data-id="element-374">
              1
            </span>
            <span className="text-gray-700" data-id="element-375">
              Communicate professionally and effectively with executives,
              stakeholders, and team members at all organizational levels
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-376">
            <span className="flex-shrink-0 w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold" data-id="element-377">
              2
            </span>
            <span className="text-gray-700" data-id="element-378">
              Master complex calendar management, scheduling coordination, and
              priority management for busy executives
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-379">
            <span className="flex-shrink-0 w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold" data-id="element-380">
              3
            </span>
            <span className="text-gray-700" data-id="element-381">
              Build and maintain strong stakeholder relationships through trust,
              collaboration, and professional excellence
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-382">
            <span className="flex-shrink-0 w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold" data-id="element-383">
              4
            </span>
            <span className="text-gray-700" data-id="element-384">
              Provide strategic decision support and position yourself as a
              valuable advisor to leadership
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-385">
            <span className="flex-shrink-0 w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold" data-id="element-386">
              5
            </span>
            <span className="text-gray-700" data-id="element-387">
              Apply practical tools, templates, and systems through real-world
              simulations and hands-on practice
            </span>
          </li>
        </ul>
      </div>
    </section>;
}